import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPartnerPlans, setSelectedPlan } from 'actions/partnerPlans'
import { getPartnerPlanDocuments } from 'actions/partnerPlan'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import constants from 'constants'
import MainLayout from 'components/MainLayout'
import { commonFunctions } from 'utils/CommonFunctions'
import { hasAccess } from 'utils/hasAccess'
import { modalShow, modalHide } from 'actions/modals'
import { getEmployeeId } from 'utils/getEmployeeId'
import { headerTitleName } from 'utils/headerTitleName'
import PartnerPlanDocumentForm from 'containers/PartnerPlanDocumentForm'

class PartnerPlanReport extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getPartnerPlans: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    partnerPlans: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    selectedPartner: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
    setSelectedPlan: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    partnerPlans: null,
    selectedPartner: null,
    currentUser: null,
  }

  /* constructor(props) {
    super(props)
    this.state = {
      partnerPlanDocuments: [],
    }
  } */

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Partner Plan', this.props.history)
    this.props.getPartnerPlans(
      constants.PARTNERPLAN.VIEW.REVIEWPLANS,
      getEmployeeId(this.props.selectedPartner, this.props.currentUser),
    )
  }

  handleDownloadSelectedPlan = (plan) => {
    this.props.setSelectedPlan(plan)
    setTimeout(() => {
      this.props.getPartnerPlanDocuments(
        plan.EmployeeId,
        plan.PlanYear,
        plan.PlanStatus,
        plan.Role,
      )
    }, 100)
    this.props.modalShow('partnerPlanDocumentForm')
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Reports'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  showSidebar() {
    const locationPath = this.props.location.pathname
    const { routes } = this.props
    const currentRouteData = (routes.find(i => i.path === locationPath) || {}).data
    if (!currentRouteData || currentRouteData.showSidebar === null) { return true }
    return currentRouteData.showSidebar
  }

  render() {
    const {
      routes, currentUser, partnerPlans, selectedPartner, partnerPlan, selectedPlan,
    } = this.props
    const sidebar = (currentUser.IsAdmin && this.props.location.pathname.indexOf('admin/') > -1) ? 'partnerAdmin' : 'partnerSideBar'
    return (
      <div>
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          currentUser={this.props.currentUser}
          partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
          showSidebar={this.showSidebar()}
          sidebarType={sidebar}
        >
          <Container>
            {routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...route}
                currentReportId={this.props.currentReportId}
                currentReportURL={this.props.currentReportURL}
                currentUser={currentUser}
                getPartnerPlans={this.props.getPartnerPlans}
                handleDownloadSelectedPlan={this.handleDownloadSelectedPlan}
                partnerPlans={partnerPlans}
                planView={constants.PARTNERPLAN.VIEW.REVIEWPLANS}
                reports={this.props.reports}
                selectedPartner={selectedPartner}
                setErrorMessage={this.props.setErrorMessage}
              />
            ))}
          </Container>
          <PartnerPlanDocumentForm
            currentUser={currentUser}
            hide={this.props.modalHide}
            partnerPlan={partnerPlan}
            selectedPlan={selectedPlan}
          />
        </MainLayout>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlans: state.partnerPlans,
  partnerPlan: state.partnerPlan,
  reports: state.reports,
  currentReportURL: state.reports.currentReportUrl,
  currentReportId: state.reports.currentReportId,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  setSelectedPlan,
  getPartnerPlans,
  getPartnerPlanDocuments,
  modalShow,
  modalHide,
})(PartnerPlanReport))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanReport.js